import { Variants } from "framer-motion";

// Fade up animation for elements
export const fadeUp: Variants = {
  hidden: { 
    opacity: 0, 
    y: 20 
  },
  visible: (custom = 0) => ({ 
    opacity: 1, 
    y: 0,
    transition: {
      delay: custom * 0.2,
      duration: 0.6,
      ease: [0.215, 0.61, 0.355, 1]
    }
  })
};

// Staggered container animation to animate children sequentially
export const staggerContainer: Variants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};

// Floating animation for decorative elements
export const floatingAnimation: Variants = {
  initial: { y: 0 },
  float: {
    y: [0, -10, 0],
    transition: {
      duration: 6,
      repeat: Infinity,
      ease: "easeInOut"
    }
  }
};

// Card hover animations
export const cardHover: Variants = {
  initial: { y: 0, boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)" },
  hover: { 
    y: -5, 
    boxShadow: "0 10px 25px rgba(180, 84, 180, 0.15)",
    transition: {
      duration: 0.3,
      ease: "easeOut"
    }
  }
};

// Video card hover animations
export const videoCardHover: Variants = {
  initial: { scale: 1, boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)" },
  hover: { 
    scale: 1.02, 
    boxShadow: "0 10px 30px rgba(180, 84, 180, 0.2)",
    transition: {
      duration: 0.3,
      ease: "easeOut"
    }
  }
};
